export default "__VITE_ASSET__CwBCVCgT__"